/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SearchNestedAggregation } from './searchNestedAggregation';

export interface SearchAggregationBucket { 
    /**
     * Number of search documents that are grouped within this bucket
     */
    aggregated_items_count: number;
    /**
     * Attribute-specific object structure representing it's key, used to group documents into bucket
     */
    aggregation_key: any;
    /**
     * Bodies of nested aggregation buckets
     */
    nested_aggregations?: Array<SearchNestedAggregation>;
}